var map = {
	"./dobby/dobby_brand_logo.png": "c53b",
	"./dobby/dobby_logo.png": "6845",
	"./images/dankoff_logo.png": "3215",
	"./images/hermelin_brand_logo.png": "5c43",
	"./images/keisi_logo.png": "5845",
	"./keisi/keisi_brand_logo.png": "2703",
	"./keisi/keisi_logo.png": "807e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "08ce";